<select
  class="cr-segment-select"
  aria-label="Choose a segment for the link"
  [ngModel]="selectedSegment?.content ?? ''"
  (ngModelChange)="onChange($event)"
>
  <option *ngFor="let segment of segments" [value]="segment.content">{{ segment.displayName }}</option>
</select>
